import { PROJECT_WIDGETS, TODAY_WIDGETS, FINANCE_WIDGETS, type TodayWidgetDefinition } from '@scrambl/shared';

export type { TodayWidgetDefinition };
export const WIDGET_DEFINITIONS: TodayWidgetDefinition[] = [
  ...PROJECT_WIDGETS,
  ...TODAY_WIDGETS,
  ...FINANCE_WIDGETS
];
